import sanityClient from '@sanity/client'
import imageUriBuilder from '@sanity/image-url'

export const client = sanityClient({
   projectId:process.env.REACT_APP_SANITY_PROJECT_ID, 
   dataset: 'production',
   apiVersion: '2023-01-17',
   useCdn: true,
   token:process.env.REACT_APP_SANITY_TOKEN,
});

const builder = imageUriBuilder(client);

export const urlFor = (source) => builder.image(source);